import { CountdownTwo, FAQSection } from "@modules/study/common/sections";
import { getAssets } from "@unisearch/helpers";
import React, { useRef } from "react";
import { Fragment } from "react";
import styles from "./landing.module.scss";
import VFairHowAttend from "./_sections/how_attend";
import VFairImpactCount from "./_sections/impact_count";
import UpcomingEvent from "./_sections/upcoming_event";
import VFairWhyAttend from "./_sections/why_attend";
import { FindUniversity } from "@modules/study/home";

const faqData = [
  {
    id: 1,
    faqQuestion: "1. Is there a charge for UniSearch’s counselling services?",
    faqAnswer:
      "<p>No, UniSearch does not charge you for our study abroad counselling services! When you are applying to the UK, Australia, Canada, Ireland and/or New Zealand, fees are only payable to the university, immigration bodies, and other relevant authorities involved in your application.</p><p>If you are planning on applying to the USA, we do charge a fee to cover the administrative costs of completing the process!</p>",
  },
  {
    id: 2,
    faqQuestion:
      "2. Can you help me with my university and visa application to study abroad?",
    faqAnswer:
      "<p>Of course, that’s exactly what UniSearch is here to do! As the top study abroad consultants in Bangalore and India, we pride ourselves for our complete end-to-end support of our students before, during, and after the application process. We guide you through your program and university research with tailored shortlists matching your profile and preferences. We then support you through the full application process - including guidance for your LOR and SOP, English language tests, and scholarship applications. Our support goes beyond your applications too - we assist with visa processing, as well as accommodation search and student job opportunities at your destination.</p>",
  },
  {
    id: 3,
    faqQuestion: "3. Can you help me get a scholarship to study abroad?",
    faqAnswer:
      "<p>Our overseas education counsellors help you discover scholarship opportunities that you are eligible for and support your applications! You can also access education loan support through UniSearch.</p>",
  },
  {
    id: 4,
    faqQuestion:
      "4. Can you help me find accommodation at my study abroad destination?",
    faqAnswer:
      "<p>UniSearch works with several accommodation providers in major study abroad destinations to help you secure student housing.</p>",
  },
  {
    id: 5,
    faqQuestion: "5. Does UniSearch waive application fees for students?",
    faqAnswer:
      "<p>You’re in luck, because yes, we do! As top overseas education consultants, several of our partner universities waive application fee requirements for our students. Get in touch with us to find out which universities you can apply to without an application fee!</p>",
  },
  {
    id: 6,
    faqQuestion: "6. Can UniSearch help me with my SOP and LOR?",
    faqAnswer:
      "<p>Our expert team of international education consultants have decades of experience helping students craft successful applications. And this expertise includes helping students put together impactful statements of purpose (SOP) and letters of reference/referral (LOR)!</p>",
  },
  {
    id: 7,
    faqQuestion:
      "7. I can’t visit UniSearch in-person - can you still help me?",
    faqAnswer:
      "<p>We definitely can! Our core commitment at UniSearch is to help every student access their ideal study abroad journey. Along with our physical branches, you can also connect with the best study abroad consultants in Bangalore and India through our <a class='color-orange fw600' href='https://us06web.zoom.us/j/94960983299?pwd=N093UkVZd0JoMXczbmdhdTl4cWJ6UT09' target='_blank' rel='nofollow' >virtual office.</a></p>",
  },
];

const VfairLanding = ({ partnerUniversities }) => {
  const upcomingEventRef = useRef(null);
  const goToUpcomingEvent = () => {
    upcomingEventRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <Fragment>
      <section className={styles.section_hero}>
        <div className="container">
          <div className={styles.hero_content_wrapper}>
            <div className={styles.hero_left}>
              <h1>
                World's First & Largest Online{" "}
                <span className="mark color-orange">University Fair</span>{" "}
                Platform
              </h1>
              <p>
                Interact one on one with top university representatives, apply
                with one click and secure on-spot offers and scholarships
              </p>
              <button
                onClick={goToUpcomingEvent}
                className="btn btn-secondary btn-md btn-round"
                style={{ marginTop: "25px" }}
              >
                View Upcoming Events
              </button>
            </div>
            <div className={styles.hero_right}>
              <img src={getAssets("assets/images/vfair/vfair.webp")} />
            </div>
          </div>
        </div>
      </section>

      <div ref={upcomingEventRef}>
        <UpcomingEvent />
      </div>

      {/* <VFairImpactCount /> */}

      <CountdownTwo />
      <FindUniversity customClasses={{ root: "mb-0 lg:mb-[80px]" }} />
      <VFairWhyAttend />
      <VFairHowAttend />
      <FAQSection title="Frequently Asked Questions (FAQs)" faqData={faqData} />
    </Fragment>
  );
};

export default VfairLanding;
